import React from "react";

import photo1 from "./img/Mr_Pramod_Photo.png";
import photo2 from "./img/Miss_Priya_Photo.png";

const editors = [
  { 
    id: 1, 
    img: photo1,
    email: 'pramodneel8@gmail.com', 
    name: "Mr. Pramod Neel" 
  },
  { 
    id: 2, 
    img: photo2,
    email: 'priya@gmail.com', 
    name: "Miss. Priya Gaikwad" 
  }
];
function Contact() {
  return (
    <div>

        <div class="page-header">
                <div class="container">
                    <div class="row">
                        <div class="col-12">
                            <h2>Contact Us</h2>
                            <h5 style={{'color':'white'}}>“Get in touch with us for any inquiries, project discussions, or collaboration opportunities.”</h5>
                        </div>
                        
                    </div>
                </div>
            </div>

      {/* Contact Section */}
      <div className="contact">
        <div className="container">
          <div className="row">

            {/* Left Side */}
            <div className="col-md-6">
              <h2 className="section-title">Get In Touch</h2>

              <div className="contact-info">





                <iframe
                  src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d120650.1941082598!2d74.63961019605979!3d19.093675611312417!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3bdcb05d46788921%3A0x6677e92c1a5181b6!2sAhilyanagar%2C%20Maharashtra!5e0!3m2!1sen!2sin!4v1777128339109!5m2!1sen!2sin"
                  title="map"
                  style={{ border: 0, width: "100%", height: "250px" }}
                  allowFullScreen=""
                  loading="lazy"
                ></iframe>

                <h3>How to reach us:</h3>
                <p>
                   Office Open Hours:<br/>
                Mon - Fri : 08:00 AM To 08:00 PM
                </p>

                <h3>
                  Mobile <span>+91 976526001</span>
                </h3>

                <h3>
                  E-mail <span>hr@lthitsolutions.com</span>
                </h3>

              </div>
            </div>

            {/* Right Side */}
            <div className="col-md-6">
              <div className="editor-info">

                <h2 className="section-title">Contact Person</h2>

                {editors.map((person) => (
                  <div key={person.id} className="editor-item">

                    <div className="editor-img">
                      <img src={person.img} alt="Editor" height="400px" />
                    </div>

                    <div className="editor-text">
                      <h3>{person.name}</h3>
                      <a href="mailto:email@example.com">Email Now</a>
                    </div>

                  </div>
                ))}

              </div>
            </div>

          </div>
        </div>
      </div>

      {/* Call To Action */}
      

    </div>
  );
}

export default Contact;